module.exports = __webpack_public_path__ + "img/a.57bb0597.png";